import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router } from '@angular/router';
import Swal from 'sweetalert2';

@Injectable({
  providedIn: 'root'
})
export class UserMatchGuard implements CanActivate {

  constructor(private router: Router) {}

  canActivate(route: ActivatedRouteSnapshot): boolean {
    // logged userId from localStorage
    const userDetails = localStorage.getItem('user_details');
    if (!userDetails) {
      this.router.navigate(['/web/home']);
      return false;
    }

    let loggedUser: any;
    try {
      loggedUser = JSON.parse(userDetails);
    } catch {
      this.router.navigate(['/web/home']);
      return false;
    }

    const loggedUserId = loggedUser?.userDetail?.userID;
    if (!loggedUserId) {
      this.router.navigate(['/web/home']);
      return false;
    }

    // encoded query params string
    const encoded = route.queryParams['queryParams'];

    if (!encoded) {
      // no URL params – allow
      return true;
    }

    // decode BASE64
    const decoded = atob(encoded); // e.g. "projectId=1&userId=61"

    // convert to key/value object
    const paramsObj = this.getParamsObject(decoded);

    // userId from URL params
    const urlUserId = paramsObj['logedInUserId'];

    if (urlUserId && urlUserId.toString() !== loggedUserId.toString()) {
      Swal.fire({
        icon: 'error',
        title: 'Access Denied',
        text: 'You are not authorized to view this user’s project.',
      }).then(() => {
        window.history.back();
      });

      return false;
    }

    return true;
  }

  // helper: convert "a=1&b=2" => {a:"1",b:"2"}
  private getParamsObject(decodedString: string) {
    const paramsArr = decodedString.split('&');
    const obj: any = {};
    paramsArr.forEach(p => {
      const [k, v] = p.split('=');
      obj[k] = v;
    });
    return obj;
  }
}
